var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretRightSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 191.9 320",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184.8,139.9c10.2,12.6,9.5,31.1-2.2,42.8L54.6,310.7c-9.2,9.2-22.9,11.9-34.9,6.9S0,301,0,288.1V32.1C0,19.2,7.8,7.5,19.8,2.5S45.5.3,54.7,9.4l128,128,2.2,2.4h-.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretRightSolid);
export default __webpack_public_path__ + "static/media/caret-right-solid.0dfe9453cf133d80d7c7bd6b3a320ecc.svg";
export { ForwardRef as ReactComponent };